import { RateSheetTableRowState } from "../../../rate-sheet/reducer";

export const priceRowNeedsRecalculation = (
  r: RateSheetTableRowState
): boolean => r.editable.volume == null || r.editable.avgGrossPrice == null;
